// Global function to sync header cart count with actual cart state accessible from product page, cart drawer, etc

window.refreshHeaderCartCount = async function () {
  try {
    const res = await axios.get("/cart.js");
    const countBadges = document.querySelectorAll("[data-cart-count]");
    countBadges.forEach((badge) => {
      if (badge) {
        badge.textContent = res.data.item_count;
      }
    });
  } catch (err) {
    console.error("Header count sync failed:", err);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  const shopMenu = document.querySelector(".shop-menu");
  const secondaryNav = document.querySelector(".secondary-navigation");
  const nav = document.querySelector("nav");
  const primaryNav = document.querySelector(".primary-navigation");
  const header = document.querySelector("header");

  shopMenu.addEventListener("click", (e) => {
    e.preventDefault();
    secondaryNav.style.display = "block";
    header.classList.add("secondary-nav-open");
  });

  document.addEventListener("click", (e) => {
    if (!nav.contains(e.target)) {
      secondaryNav.style.display = "none";
      header.classList.remove("secondary-nav-open");
    }
  });

  //Event: Change header background and logo on scroll
  let ticking = false;
  let productImagesScrolled = 0;
  const targetPages = ["products", "pages", "customers", "collections/all"];
  const currentUrl = window.location.href;
  const isTargetPage = targetPages.some((page) => currentUrl.includes(page));
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  console.log("DOMLoaded");
  if (pathParts[0] === "products" && window.innerWidth < 860) {
    header.classList.remove("on-top-non-cover");
    console.log("mobile product");
  }

  function updateNav() {
    //For product pages
    if (pathParts[0] === "products" && window.innerWidth >= 1040) {
      const productImagesContainer = document.querySelector(".product-images");
      productImagesScrolled = productImagesContainer.scrollTop;
      const effectiveScroll = Math.max(productImagesScrolled, window.scrollY);

      if (effectiveScroll <= 30) {
        header.classList.add("on-top-non-cover");
      } else if (effectiveScroll >= 40) {
        header.classList.remove("on-top-non-cover");
      }
    } else if (pathParts[0] === "products" && window.innerWidth < 860) {
      header.classList.remove("on-top-non-cover");
    } else {
      if (window.scrollY <= 30) {
        if (isTargetPage) header.classList.add("on-top-non-cover");
        else header.classList.add("on-top-cover");
      } else if (window.scrollY >= 40) {
        if (isTargetPage) header.classList.remove("on-top-non-cover");
        else header.classList.remove("on-top-cover");
      }
    }

    ticking = false;
  }

  window.addEventListener("wheel", () => {
    if (!ticking) {
      requestAnimationFrame(updateNav);
      ticking = true;
    }
  });
  window.addEventListener("scroll", () => {
    if (!ticking) {
      requestAnimationFrame(updateNav);
      ticking = true;
    }
  });

  // Navigation drawer submenu expansion
  const allSubmenuItems = document.querySelectorAll(".submenu-container");
  allSubmenuItems.forEach((subMenuItem) => {
    const subMenuTitleContainer = subMenuItem.querySelector(
      ".submenu-title-container",
    );
    subMenuTitleContainer.addEventListener("click", function () {
      allSubmenuItems.forEach((item) => {
        if (item !== this) {
          item.classList.remove("expanded-submenu");
        }
      });
      //toggle expanded class in clicked menu item
      subMenuItem.classList.toggle("expanded-submenu");
    });
  });
  //Toggle nav-drawer
  const hamburger = document.querySelector(".hamburger");
  const navDrawer = document.querySelector(".nav-drawer");
  const closeNavBtn = document.querySelector(".close-nav");
  const navOverlay = document.querySelector(".nav-overlay");

  function openNav() {
    navDrawer.classList.add("sidenav-open");
    navOverlay.classList.add("active");
  }
  function closeNav() {
    navDrawer.classList.remove("sidenav-open");
    navOverlay.classList.remove("active");
  }
  hamburger.addEventListener("click", openNav);
  closeNavBtn.addEventListener("click", closeNav);
  navOverlay.addEventListener("click", closeNav);
});
